<script>
import {
  RelationshipTypeApi,
  RelationshipTypeConstruct,
  ApiRequest,
} from '@chirhos/chirhos-api'
import { ChiRhos , PaladinCoreStateHelpers } from '@paladin/core'


let ChiRhosApi = new ChiRhos().api()

var relationshipTypeApi = new RelationshipTypeApi(ChiRhosApi)

export default {
  page() {
    return {
      title: 'Tenant | Relationship Types',
    }
  },
  components: {},
  computed: {
    ...PaladinCoreStateHelpers.userComputed,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      addRelationshipTypeForm: {
        forwardsDescription: '',
        reverseDescription: '',
      },
      selectedRelationshipType: null,
      relationshipTypes: null,
    }
  },
  mounted() {
    this.initRelationshipTypes()
  },
  methods: {
    initRelationshipTypes() {
      if(this.isChiRhosOwner || this.isTenantOwner || this.isTenantAdmin)
      {
        relationshipTypeApi
          .List({
            request: new ApiRequest(),
          })
          .then(
            (response) => {
              this.relationshipTypes = response.data
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )
      }
    },
    viewDetail(data) {
      this.selectedRelationshipType = data
    },
    newRelationshipTypeSubmit(evt) {
      evt.preventDefault()
      // var _selectedNode = this.page.selectedNode
      relationshipTypeApi
        .Save({
          value: new RelationshipTypeConstruct(
            this.addRelationshipTypeForm.forwardsDescription,
            this.addRelationshipTypeForm.reverseDescription
          ),
        })
        .then(
          (/* dat a */) => {
            this.addRelationshipTypeForm.forwardsDescription = ''
            this.addRelationshipTypeForm.reverseDescription = ''

            this.initRelationshipTypes()
            this.$toast('Group successfully saved', 'success')
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
  },
}
</script>

<template>
  <b-row>
    <b-col lg="7" md="7" sm="7">
      <b-card title="Manage Relationship Types" class="card-profile">
        <div v-if="relationshipTypes">
          <div
            v-for="type in relationshipTypes"
           :key="type.entity.entityId"
          >
            <div>
              <span @click="viewDetail(type.entity)">
                {{ type.entity.forwardsDescription }} -
                {{ type.entity.reverseDescription }}
              </span>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col lg="5" md="5" sm="5">
      <b-card
        v-if="selectedRelationshipType"
        title="Edit Relationship Type"
        class="card-profile"
      >
        <div>
          <strong>Entity Id:</strong>
          {{ selectedRelationshipType.entityId }}
          <br />
          <strong>Forwards Description:</strong>
          {{ selectedRelationshipType.forwardsDescription }}
          <br />
          <strong>Reverse Description:</strong>
          {{ selectedRelationshipType.reverseDescription }}
          <br />
        </div>
      </b-card>
      <b-card
        v-else
        title="Select a relationship type to edit"
        class="card-profile"
      />
      <b-card title="Add New Relationship Type" class="card-profile">
        <b-form @submit="newRelationshipTypeSubmit">
          <label>Forwards Description</label>
          <b-input
            v-model="addRelationshipTypeForm.forwardsDescription"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="Enter a forwards description"
            required
          />
          <label>Reverse Description</label>
          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
            <b-input
              v-model="addRelationshipTypeForm.reverseDescription"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Enter a reverse description"
              required
            />
          </b-input-group>
          <b-button type="submit" variant="primary">Save</b-button>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>
